(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-interest-form-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-ss-interest-shell]:not([data-ss-initialized])').forEach(shell => {
      shell.dataset.ssInitialized = 'true';
      const target = shell.querySelector('[data-ss-form-target]');
      const intro = shell.querySelector('[data-ss-form-intro]');
      const loading = shell.querySelector('[data-ss-form-loading]');
      const fallback = shell.querySelector('[data-ss-form-fallback]');
      const dialog = shell.closest('dialog');
      let expired = false;
      let timer;
      let opened = false;
      let hasMounted = false;
      const usable = () => [...target.querySelectorAll('input:not([type="hidden"]), textarea, select')].some(control => {
        if (control.disabled || control.closest('[hidden], [aria-hidden="true"]')) return false;
        const style = getComputedStyle(control);
        return style.display !== 'none' && style.visibility !== 'hidden' && control.getClientRects().length > 0;
      });
      const update = () => {
        if (dialog && !dialog.open) return;
        hasMounted = hasMounted || usable();
        const mounted = hasMounted;
        if (mounted) clearTimeout(timer);
        intro.hidden = mounted;
        loading.hidden = mounted || expired;
        fallback.hidden = mounted || !expired;
        target.setAttribute('aria-busy', String(!mounted && !expired));
      };
      const openState = () => {
        const isOpen = !dialog || dialog.open;
        if (isOpen && !opened) {
          expired = false;
          clearTimeout(timer);
          timer = setTimeout(() => { expired = true; update(); }, 10000);
        } else if (!isOpen) {
          clearTimeout(timer);
        }
        opened = isOpen;
        update();
      };
      new MutationObserver(update).observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'disabled']
      });
      if (dialog) new MutationObserver(openState).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      openState();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-launch-card-media"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ss-bottle-spin')) return;

  // 36-frame turntable stored as four 3 x 3 sheets (frame n = sheet n % 4, cell floor(n / 4)).
  const FRAMES = 36;
  const SHEETS = 4;
  const GRID = 3;
  const mod = (n, m) => ((n % m) + m) % m;
  const ease = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const still = () => reduce.matches || document.documentElement.classList.contains('sf-motion-paused');
  let nearObserver;
  let viewObserver;
  const near = () => nearObserver || (nearObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) entry.target.load(); }), { rootMargin: '360px 0px' }));
  const view = () => viewObserver || (viewObserver = new IntersectionObserver(entries => entries.forEach(entry => entry.target.onView(entry)), { threshold: [0, 0.2, 0.6] }));

  class SSBottleSpin extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.mode = this.dataset.mode || 'card';
      this.url = this.dataset.frames || '';
      this.order = (this.dataset.sheets || '0,2,1,3').split(',').map(Number).filter(n => n >= 0 && n < SHEETS);
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
      this.sheets = this.sheets || new Array(SHEETS);
      this.pos = this.pos || 0;
      this.key = '';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      near().observe(this);
      view().observe(this);
      if (this.mode === 'card') this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.spin(); }, { signal });
      if (this.mode === 'stage') this.bindDrag(signal);
    }

    disconnectedCallback() {
      this.bound = false;
      nearObserver && nearObserver.unobserve(this);
      viewObserver && viewObserver.unobserve(this);
      this.controller && this.controller.abort();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
    }

    onView(entry) {
      if (entry.intersectionRatio >= 0.6 && !this.inView) {
        this.inView = true;
        if (this.mode !== 'scrub') this.spin();
      } else if (entry.intersectionRatio < 0.2) {
        this.inView = false;
      }
    }

    sheetUrl(index) {
      const height = (this.clientHeight || 320) * Math.min(window.devicePixelRatio || 1, 2);
      const max = this.mode === 'card' ? 720 : 1620;
      const width = Math.min(max, Math.max(540, Math.ceil((height * 2) / 180) * 180));
      const file = this.url.replace(/-s0(\.[a-z0-9]+)/i, '-s' + index + '$1');
      return file + (file.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    load() {
      if (this.loading || !this.url) return this.loading;
      this.loading = this.order.reduce((chain, index) => chain.then(() => new Promise(done => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => {
          const decoded = image.decode ? image.decode().catch(() => {}) : Promise.resolve();
          decoded.then(() => { this.sheets[index] = image; this.ready(); done(); });
        };
        image.onerror = () => done();
        image.src = this.sheetUrl(index);
      })), Promise.resolve());
      return this.loading;
    }

    ready() {
      if (!this.ctx) return;
      const first = this.sheets.find(Boolean);
      if (!first) return;
      const width = Math.round(first.naturalWidth / GRID);
      const height = Math.round(first.naturalHeight / GRID);
      if (this.canvas.width !== width || this.canvas.height !== height) { this.canvas.width = width; this.canvas.height = height; }
      this.key = '';
      this.classList.add('has-frames');
      if (this.mode !== 'card') this.classList.add('is-live');
      this.draw(true);
      if (this.pending) { this.pending = false; if (this.inView || this.mode !== 'card') this.spin(true); }
    }

    frame(index) {
      const sheet = this.sheets[index % SHEETS];
      if (!sheet) return null;
      const cell = Math.floor(index / SHEETS);
      const w = sheet.naturalWidth / GRID;
      const h = sheet.naturalHeight / GRID;
      return { image: sheet, sx: (cell % GRID) * w, sy: Math.floor(cell / GRID) * h, w, h };
    }

    // Draws the nearest loaded frames, cross-fading between them so partial sheets still turn smoothly.
    draw(force) {
      if (!this.ctx) return;
      const p = mod(this.pos, FRAMES);
      let ia = Math.floor(p);
      let ib = ia + 1;
      let fa = null;
      let fb = null;
      for (let o = 0; o < SHEETS && !fa; o++) { fa = this.frame(mod(ia - o, FRAMES)); if (fa) ia -= o; }
      for (let o = 0; o < SHEETS && !fb; o++) { fb = this.frame(mod(ib + o, FRAMES)); if (fb) ib += o; }
      if (!fa && !fb) return;
      if (!fa) { fa = fb; ia = ib; }
      if (!fb) { fb = fa; ib = ia; }
      const t = ib === ia ? 0 : Math.min(1, Math.max(0, (p - ia) / (ib - ia)));
      const key = mod(ia, FRAMES) + ':' + mod(ib, FRAMES) + ':' + Math.round(t * 16);
      if (!force && key === this.key) return;
      this.key = key;
      const ctx = this.ctx;
      const { width, height } = this.canvas;
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(fa.image, fa.sx, fa.sy, fa.w, fa.h, 0, 0, width, height);
      if (t > 0.04 && fb !== fa) {
        ctx.globalAlpha = t;
        ctx.drawImage(fb.image, fb.sx, fb.sy, fb.w, fb.h, 0, 0, width, height);
        ctx.globalAlpha = 1;
      }
    }

    spin(force) {
      if (still() || !this.url || this.dragging) return;
      const now = performance.now();
      if (!force && now - (this.lastSpin || 0) < 1800) return;
      if (!this.sheets.some(Boolean)) { this.pending = true; this.load(); return; }
      this.lastSpin = now;
      const from = Math.round(this.pos);
      this.velocity = 0;
      this.anim = { from, to: from + FRAMES, start: now, duration: this.mode === 'card' ? 1500 : 2300 };
      this.classList.add('is-live', 'is-spinning');
      this.loop();
    }

    setAngle(degrees) {
      if (still()) return;
      this.pos = (degrees / 360) * FRAMES;
      if (!this.sheets.some(Boolean)) { this.load(); return; }
      this.draw();
    }

    loop() {
      if (this.raf) return;
      const step = now => {
        this.raf = 0;
        let busy = false;
        if (this.anim) {
          const k = Math.min(1, (now - this.anim.start) / this.anim.duration);
          this.pos = this.anim.from + (this.anim.to - this.anim.from) * ease(k);
          if (k >= 1) {
            this.pos = mod(Math.round(this.pos), FRAMES);
            this.anim = null;
            this.classList.remove('is-spinning');
            if (this.mode === 'card') this.classList.remove('is-live');
          } else busy = true;
        } else if (!this.dragging && Math.abs(this.velocity || 0) > 0.02) {
          this.pos += this.velocity;
          this.velocity *= 0.93;
          busy = true;
        } else if (!this.dragging && this.pos !== Math.round(this.pos)) {
          this.pos = Math.round(this.pos);
          this.velocity = 0;
        }
        this.draw();
        if (busy) this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }

    // Stage mode: drag with a mouse or pen (touch swipes stay with the gallery), arrow keys turn it.
    bindDrag(signal) {
      let id = null;
      let startX = 0;
      let startPos = 0;
      let lastX = 0;
      let lastT = 0;
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button > 0) return;
        id = event.pointerId;
        try { this.setPointerCapture(id); } catch (error) {}
        this.dragging = true;
        this.anim = null;
        this.velocity = 0;
        startX = lastX = event.clientX;
        startPos = this.pos;
        lastT = event.timeStamp;
        this.load();
        this.classList.add('is-live', 'is-dragging');
        event.preventDefault();
      }, { signal });
      this.addEventListener('pointermove', event => {
        if (!this.dragging || event.pointerId !== id) return;
        const perPixel = FRAMES / Math.max(260, this.clientWidth * 2.4);
        this.pos = startPos - (event.clientX - startX) * perPixel;
        const dt = Math.max(1, event.timeStamp - lastT);
        this.velocity = -(event.clientX - lastX) * perPixel * (16 / dt);
        lastX = event.clientX;
        lastT = event.timeStamp;
        this.draw();
      }, { signal });
      const end = event => {
        if (!this.dragging || event.pointerId !== id) return;
        this.dragging = false;
        this.classList.remove('is-dragging');
        this.velocity = Math.max(-1.6, Math.min(1.6, this.velocity || 0));
        this.lastSpin = performance.now();
        this.loop();
      };
      this.addEventListener('pointerup', end, { signal });
      this.addEventListener('pointercancel', end, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home') return;
        event.preventDefault();
        event.stopPropagation();
        this.load();
        this.anim = null;
        this.velocity = 0;
        this.classList.add('is-live');
        this.pos = event.key === 'Home' ? 0 : this.pos + (event.key === 'ArrowRight' ? -2 : 2);
        this.draw(true);
      }, { signal });
    }
  }

  customElements.define('ss-bottle-spin', SSBottleSpin);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-restock-card"] && !Shopify.designMode) return;
  try {
    (() => {
  function openRestock(button) {
    const dialog = document.getElementById(button.dataset.restockTarget);
    const root = button.closest('[data-product-root]');
    if (!dialog || !root) return;
    const input = root.querySelector('.sf-main-add-form [name="id"]');
    const data = JSON.parse(root.querySelector('[data-variant-data]').textContent);
    const variant = data.variants.find(item => String(item.id) === String(input?.value));
    if (!variant || variant.available) return;
    const currentUrl = new URL(location.href);
    if (String(variant.id) !== dialog.dataset.initialVariant || currentUrl.searchParams.get('variant') !== String(variant.id)) {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(variant.id));
      url.hash = 'ss-notify';
      location.assign(url.href);
      return;
    }
    if (dialog.open || typeof dialog.showModal !== 'function') return;
    dialog._ssTrigger = button;
    dialog.showModal();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ss-restock-open]');
    if (button) {
      event.preventDefault();
      openRestock(button);
      return;
    }
    const close = event.target.closest('[data-ss-restock-close]');
    if (close) close.closest('dialog')?.close();
    const dialog = event.target;
    if (dialog.matches('[data-ss-restock-dialog]')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  function initialize(scope) {
    scope.querySelectorAll('[data-ss-restock-dialog]:not([data-ss-dialog-ready])').forEach(dialog => {
      dialog.dataset.ssDialogReady = 'true';
      dialog.addEventListener('close', () => dialog._ssTrigger?.focus());
      dialog.closest('[data-product-root]')?.addEventListener('sf:variant-updated', () => {
        if (dialog.open) dialog.close();
      });
    });
    if (location.hash === '#ss-notify') {
      const button = document.querySelector('[data-main-add][data-ss-restock-open]');
      if (button) {
        const url = new URL(location.href);
        url.hash = '';
        history.replaceState({}, '', url);
        openRestock(button);
      }
    }
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-scent-request-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const open = event.target.closest('[data-ss-request-open]');
  const close = event.target.closest('[data-ss-request-close]');
  const dialog = document.getElementById('ss-scent-request-dialog');
  if (open && dialog && typeof dialog.showModal === 'function' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
    event.preventDefault();
    if (!dialog.open) {
      dialog._ssTrigger = open;
      dialog.showModal();
    }
  }
  if (close && dialog) dialog.close();
  if (event.target === dialog) {
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  }
});
document.addEventListener('close', event => {
  if (event.target.id === 'ss-scent-request-dialog') event.target._ssTrigger?.focus();
}, true);
  } catch(e) { console.error(e); }
})();

})();
